.ico-hyperlink,
.ico-hyperlink:visited,
.ico-hyperlink:active {
  color: var(--clrs-hyperlink-text);
}

.ico-hyperlink:hover {
  color: var(--clrs-hyperlink-text-hover);
}

.ico-hyperlink--on-dark,
.ico-hyperlink--on-dark:visited,
.ico-hyperlink--on-dark:active {
  color: var(--clrs-hyperlink-text-on-dark);
}

.ico-hyperlink--on-dark:hover {
  color: var(--clrs-hyperlink-text-on-dark-hover);
}

.ico-hyperlink--no-underline {
  @apply no-underline;
}
